import { useState, useRef, useEffect } from "react";
import "./SearchableSelect.css";

const SearchableSelect = ({
    StatesList,
    SelectState,
    setSelectState,
    SelectStateError,
    EnterState,
    handleEnterState,
    inputClassName = "searchable-select-input",
}) => {
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [showOtherInput, setShowOtherInput] = useState(false);
    const dropdownRef = useRef(null);

    // Filter dropdown results
    const filteredStates =
        StatesList?.filter((state) =>
            state.name.toLowerCase().includes(search.toLowerCase())
        ) || [];

    // Sync search state with selection
    useEffect(() => {
        if (SelectState && SelectState !== "Other") {
            setSearch(SelectState);
            setShowOtherInput(false);
        } else if (SelectState === "Other") {
            setSearch("Other");
            setShowOtherInput(true);
        }
    }, [SelectState]);

    // Select a state
    const handleSelectState = (stateName) => {
        if (stateName === "Other") {
            setSelectState("Other");
            setShowOtherInput(true);
        } else {
            setSelectState(stateName);
            setShowOtherInput(false);
        }
        setIsOpen(false);
    };

    // Close dropdown on outside click
    useEffect(() => {
        const handleOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, []);

    const handleSearchChange = (e) => {
        let value = e.target.value;

        value = value.replace(/[0-9]/g, "");

        value = value.replace(/[^A-Za-z\s]/g, "");

        value = value.replace(/\s+/g, " ");

        value = value.replace(/^\s+/, "");

        setSearch(value);
        setIsOpen(true);
    };

    return (
        <div className="searchable-select-container" ref={dropdownRef}>
            <div className="input-with-clear-icon">
                <div className="requestProperty-input">
                    <input
                        type="text"
                        placeholder="Select your state"
                        value={search}
                        onChange={(e) => {
                            if (!showOtherInput) handleSearchChange(e);
                        }}
                        onFocus={() => setIsOpen(true)}
                        className={inputClassName}
                        readOnly={showOtherInput}
                    />
                </div>

                {search && (
                    <span
                        className="clear-icon"
                        onClick={() => {
                            setSearch("");
                            setSelectState("");
                            handleEnterState({ target: { value: "" } });
                            setShowOtherInput(false);
                        }}
                    >
                        &times;
                    </span>
                )}
            </div>

            {isOpen && !showOtherInput && (
                <ul className="searchable-select-dropdown">
                    {filteredStates.map((state, index) => (
                        <li
                            key={index}
                            className="searchable-select-option"
                            onClick={() => handleSelectState(state.name)}
                        >
                            {state.name}
                        </li>
                    ))}

                    <li
                        className="searchable-select-option"
                        onClick={() => handleSelectState("Other")}
                    >
                        Other
                    </li>
                </ul>
            )}

            {SelectStateError && <p className="error">{SelectStateError}</p>}

            {SelectState === "Other" && (
                <div className="requestProperty-input">
                    <input
                        type="text"
                        className="property-input"
                        placeholder="Enter your state"
                        value={EnterState}
                        onChange={handleEnterState}
                    />
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;

